import { Injectable } from '@angular/core';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { Oui } from '../../models/Oui';
import { TypeAdresseFNS } from '../../models/TypeAdresseFNS';
import { TypeNumIdentificationNational } from '../../models/TypeNumIdentificationNational';
import { TypeOuiNonGrpAcheteur } from '../../models/TypeOuiNonGrpAcheteur';

@Injectable({
  providedIn: 'root'
})
export class OrganismeService {

  constructor() { }

  getOrganisme(controls){
    const organisme = new TypeAdresseFNS();
    organisme.cp = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepAtt_cp');
    organisme.ville = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepAtt_ville');
    organisme.codeIdentificationNational = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepAtt_codeIdentificationNational');
    organisme.nomOfficiel = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepAtt_nomOfficiel');
    organisme.typeIdentificationNational = new TypeNumIdentificationNational();
    organisme.typeIdentificationNational.irep = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeNumIdentificationNational_SepAtt_siret') === RadioCheckBoxEnum.irepValue ? RadioCheckBoxEnum.emptyValue : null;
    organisme.typeIdentificationNational.frwf = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeNumIdentificationNational_SepAtt_siret') === RadioCheckBoxEnum.frwfValue ? RadioCheckBoxEnum.emptyValue : null;
    organisme.typeIdentificationNational.siret = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeNumIdentificationNational_SepAtt_siret') === RadioCheckBoxEnum.siretValue ? RadioCheckBoxEnum.emptyValue : null;
    organisme.typeIdentificationNational.siren = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeNumIdentificationNational_SepAtt_siret') === RadioCheckBoxEnum.sirenValue ? RadioCheckBoxEnum.emptyValue : null;
    organisme.typeIdentificationNational.tvaIntra = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeNumIdentificationNational_SepAtt_siret') === RadioCheckBoxEnum.tvaIntraValue ? RadioCheckBoxEnum.emptyValue : null;
    organisme.typeIdentificationNational.tahiti = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeNumIdentificationNational_SepAtt_siret') === RadioCheckBoxEnum.tahitiValue ? RadioCheckBoxEnum.emptyValue : null;
    organisme.typeIdentificationNational.ridet = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeNumIdentificationNational_SepAtt_siret') === RadioCheckBoxEnum.ridetValue ? RadioCheckBoxEnum.emptyValue : null;
    organisme.grpCommandes = new TypeOuiNonGrpAcheteur();


    const ouiNon = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeOuiNonGrpAcheteur_SepAtt_non');
    if (ouiNon === 'Non') {
			organisme.grpCommandes.oui = null;
      organisme.grpCommandes.non = RadioCheckBoxEnum.emptyValue;
		} else if (ouiNon === 'Oui') {
      organisme.grpCommandes.non = null;
      organisme.grpCommandes.oui = new Oui();
      organisme.grpCommandes.oui.grpCoordonnateur= controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepSep_TypeOuiNonGrpAcheteur_SepSep_Oui_SepAtt_grpCoordonnateur')
    } else {
      organisme.grpCommandes.oui = null;
      organisme.grpCommandes.non = null;
    }

    return organisme;
  }
}
